/* lua.js generated code 0.3.0 */

var GameGuideFunc = {}
GameGuideFunc.gameEliminateAdvise = function (action, paras) {
    var self = this
    var scene = GameGuideData.getInstance().getScene()
    // if (scene === "GameScene") {
    //     var scene = cc.Director.getInstance().getRunningScene()
    //     var boardLogic = scene.logic
    //     var struct = table([0, { r: action.target.x, c: action.target.y }])
    //     for (var i = 1, v = action.items[1]; v; i++, v = action.items[i]) {
    //         table.insert(struct, { r: v.x, c: v.y })
    //     }
    //     struct.dir = { r: action.dir.x, c: action.dir.y }
    //     boardLogic.targetPossibleSwap = struct
    // }
    if (scene === "GameScene") {
        if (action.target && action.dir) {
            var scene = cc.Director.getInstance().getRunningScene()
            var boardLogic = scene.logic
            var struct = table([0, { r: action.target.x, c: action.target.y }])
            for (var i = 1, v = action.items[1]; v; i++, v = action.items[i]) {
                table.insert(struct, { r: v.x, c: v.y })
            }
            struct.dir = { r: action.dir.x, c: action.dir.y }
            boardLogic.targetPossibleSwap = struct
        } else {
            let scene = cc.Director.getInstance().getRunningScene()
            let boardLogic = scene.logic
            boardLogic.targetPossibleSwap = table()
        }
    }
}
GameGuideFunc.gameItemShow = function (action, paras) {
    let self = this
    // body
    let scene = GameGuideData.getInstance().getScene()
    if (scene === "GameScene") {
        let scene = cc.Director.getInstance().getRunningScene()
        let baseMap = scene.view.baseMap
        let total = $len(action.items)
        function callback() {
            let __VA_ARG = $slice(arguments, 0)
            // body
            total = total - 1
            if (total <= 0) {
                GameGuide.getInstance().onGuideComplete()
            }
        }
        if (total <= 0) {
            // callback()
        } else {
            // GamePlayCacheManager:getInstance():addLowActionFourTileAdvice(scene.logic.level)
            for (let i = 1, v = action.items[1]; v; i++, v = action.items[i]) {
                let [r, c] = [v.x, v.y]
                let itemView = baseMap[r][c]
                itemView.playItemShowAsTarget(action.times, action.delay)
            }
        }
    }
}
GameGuideFunc.guideProp = function (action, paras) {
    let self = this
    let level = UserLevel.getInstance().getCurrentLevel()
    if (!level) {
        return 
    }
    let meta = MetaManager.getInstance().getGuidePropMeta(action.metaId)
    function onSuccess() {
        for (let i = 1, v = meta.reward[1]; v; i++, v = meta.reward[i]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.GUIDE)
        }
    }
    let itemId = (meta.reward[1] || table()).itemId
    if (!itemId) {
        return 
    }
    let itemType = 2
    if (UserPropData.isTimeProp(itemId)) {
        itemType = 1
    } else if (UserPropData.isTempProp(itemId)) {
        itemType = 3
    } else if (UserPropData.isInfiniteProp(itemId)) {
        // 无限道具不上传
        onSuccess()
        return 
    }
    level = UserLevel.getInstance().getCurrentLevel()
    if (!level) {
        return 
    }
    // 由于游戏和引导特性 这里不得不以离线请求的方式进行
    // 不存在失败和取消的情况
    let http = GuidePropHttp.new()
    http.addEventListener(Events.kComplete, onSuccess)
    http.load(action.metaId, itemType, level.levelId)
}
GameGuideFunc.selectPropBarProp = function (action, paras) {
    var self = this
    var scene = GameGuideData.getInstance().getScene()
    if (scene === "GameScene") {
        var scene = cc.Director.getInstance().getRunningScene()
        var propBar = (scene.ui || table()).gamePropBar
        if (propBar && action.propId) {
            propBar.onItemClicked(table([1, "propId", action.propId], [1, "index", action.index]), true)
        }
    }
}
module.exports = GameGuideFunc
